"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BusinessSolutionAddOnParser = void 0;
var _constants = require("../../constants");
class BusinessSolutionAddOnParser {
  constructor(selectedBusinessSolution, addonCharacteristics) {
    this.selectedBusinessSolution = void 0;
    this.addOnCharacteristics = void 0;
    this.relevantCharacteristics = void 0;
    this.getCharacteristicByName = name => {
      return this.relevantCharacteristics.find(characteristic => {
        return characteristic.name === name;
      });
    };
    this.selectedBusinessSolution = selectedBusinessSolution;
    this.addOnCharacteristics = addonCharacteristics;
    this.relevantCharacteristics = selectedBusinessSolution.selectedVariant.characteristics.filter(characteristic => {
      return characteristic.groups.includes('addon');
    });
  }
  get AddOnSectionProps() {
    var _this$getCharacterist, _this$selectedBusines, _this$getCharacterist2;
    const name = (_this$getCharacterist = this.getCharacteristicByName(_constants.ADDON_CHARACTERISTIC_NAME)) === null || _this$getCharacterist === void 0 ? void 0 : _this$getCharacterist.valueText;
    const price = (_this$selectedBusines = this.selectedBusinessSolution.selectedVariant.price.find(price => {
      return price.priceType === _constants.PRICE_TYPES.UP_FRONT;
    })) === null || _this$selectedBusines === void 0 ? void 0 : _this$selectedBusines.priceValue;
    const costInfo = (_this$getCharacterist2 = this.getCharacteristicByName(_constants.ADDON_PRICE_INFO_NAME)) === null || _this$getCharacterist2 === void 0 ? void 0 : _this$getCharacterist2.valueText;
    const characteristics = this.relevantCharacteristics.map(characteristic => {
      var _this$addOnCharacteri;
      const icon = (_this$addOnCharacteri = this.addOnCharacteristics.find(addonCharacteristic => {
        return addonCharacteristic.name === characteristic.name;
      })) === null || _this$addOnCharacteri === void 0 ? void 0 : _this$addOnCharacteri.icon;
      return icon && {
        ...characteristic,
        iconName: icon
      };
    }).filter(characteristic => characteristic);
    const toggleButtonProps = {
      id: 'addon-toggle',
      defaultValue: true
    };
    return {
      name,
      price,
      costInfo,
      characteristics,
      toggleButtonProps
    };
  }
}
exports.BusinessSolutionAddOnParser = BusinessSolutionAddOnParser;